import {Component, EventEmitter, Input, OnInit} from "@angular/core";
import { Output } from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {UploaderOptions, UploadFile, UploadInput, UploadOutput} from "ngx-uploader";
import {environment} from "../../../../environments/environment";
import {AuthService} from "../../../services/auth/auth-service";
import {ServiceCopyControllerService} from "../../../services/service-controller/service-copy-controller.service";
import {BaseError} from "../../pages/base-error";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: "import-uploader",
  templateUrl: "import-uploader.component.html",
})
export class ImportUploaderComponent extends BaseError implements OnInit {

  @Input() public serviceUrl: string;
  private baseUrl: string = environment.BASE_URL;
  public serviceId: string;
  @Input() public buttonLabel: string;
  @Input() public hideIcon: boolean;
  @Input() public simpleButton: boolean;
  public options: UploaderOptions;
  public formData: FormData;
  public files: UploadFile[];
  public uploadInput: EventEmitter<UploadInput>;
  @Output() public fileIdChanged: EventEmitter<string>;
  public dragOver: boolean;
  public serviceCopyId: string;
  public isProcessing = false;

  constructor(private route: ActivatedRoute,
              public toastr: ToastrService,
              private authService: AuthService) {
    super(toastr);
    this.options = {concurrency: 1, maxUploads: 3};
    this.files = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    this.fileIdChanged = new EventEmitter<string>();
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = (params.serviceId === "new") ? null : params.serviceId;
    });
  }

  public onUploadOutput(output: UploadOutput): void {
    this.isProcessing = true;
    if (output.type === "allAddedToQueue") {
      this.startUpload();
    } else if (output.file && output.file.response) {
      if (output.file.responseStatus) {
        const body = "ok";
        if (output.file.responseStatus === 400) {
          output.file.response = {status: output.file.responseStatus, message: body};
        } else {
          if (output.file.response.catalogs) {
            this.serviceCopyId = output.file.response.serviceCopyId;
          } else {
            this.fileIdChanged.emit(output.file.response);
          }
        }
        this.isProcessing = false;
        output.file.response = {status: output.file.responseStatus, message: body};
      }
    }
  }

  private startUpload(): void {
    this.authService.getToken().then((token) => {
      const event: UploadInput = {
        type: "uploadAll",
        url: this.baseUrl + this.serviceUrl,
        headers: {Authorization: "Bearer " + token},
        method: "POST",
      };
      this.uploadInput.emit(event);
      this.isProcessing = false;
    });
  }

}
